import { MS_INBOX_ASSIGN_AGENT_PATH } from '../../constants/AppConstants';
import fetchWithTimeout from '../../util/fetchWithTimeout';
import { msInboxApiUrl, buildMsInboxAuthHeaders, requireMsApiPlatforms } from './msInboxClient';

/**
 * PUT assign_agent contra el microservicio inbox (mismo JSON que el monolito).
 * URL: `normalizeMsInboxBaseUrl()` + MS_INBOX_ASSIGN_AGENT_PATH (la base ya debe incluir `/api/v1`).
 * Reglas de error alineadas a MercatelyModel: cualquier HTTP !ok (incluye 422) lanza Error.
 *
 * @param {{ retailer_user_id: * , assignments: Array<{ id: *, platform: string }> }} payload
 */
export async function assignAgentMsInbox(payload) {
  const url = msInboxApiUrl(MS_INBOX_ASSIGN_AGENT_PATH);
  const headers = await buildMsInboxAuthHeaders();

  const validAssignments = requireMsApiPlatforms(payload?.assignments, 'assign_agent');

  if (validAssignments.length === 0) {
    return null;
  }

  const response = await fetchWithTimeout(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ ...payload, assignments: validAssignments }),
    mode: 'cors'
  });


  if (!response.ok) {
    const errorDetails = await response.json().catch(() => ({}));
    const errorMessage = errorDetails.message
      || errorDetails.error
      || errorDetails?.errors
      || `HTTP error! Status: ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  const json = await response.json().catch(() => null);

  // Paridad contrato inbox: fallo de negocio puede ir en cuerpo batch (p. ej. total>0 y successful===0).
  // Si el MS respondiera 200 con ese patrón, hay que fallar como el monolito para disparar rollback.
  if (json && typeof json === 'object' && json.summary && typeof json.summary === 'object') {
    const total = Number(json.summary.total);
    const successful = Number(json.summary.successful);
    if (total > 0 && successful === 0) {
      const error = new Error(
        json.message || 'Microservice assign_agent batch failed'
      );
      error.status = response.status;
      throw error;
    }
  }

  return json;
}
